<template>
  <div class="body">
    <v-alert
      :type="responseStatus.type"
      width="40%"
      style="z-index: 9999; text-align: left; margin-left: auto; margin-right: auto"
      dense
      dismissible
      v-if="typeof responseStatus.type !== 'undefined'"
      @input="handleAlert"
    >
      {{ responseStatus.text }}
    </v-alert>
    <v-card
      class="mx-auto auth"
      min-width="30%"
      max-width="360px"
      style="margin-top: 10%"
    >
      <v-img
        src="https://ourgreenfish.com/wp-content/uploads/2021/09/loyalty-hub-web-admin-logo.png"
        width="160px"
        style="margin-left: auto; margin-right: auto"
      ></v-img>

      <v-card-title class="justify-center head-title"> เข้าสู่ระบบ </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Username or email address"
            required
          ></v-text-field>

          <v-text-field
            v-model="password"
            :rules="passwordRules"
            label="Password"
            required
            type="password"
          ></v-text-field>

          <v-btn color="success" class="mr-12" @click="login"> เข้าสู่ระบบ </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { generateJwtToken } from "../../../plugins/middleware";
import axios from "axios";
export default {
  data() {
    return {
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      responseStatus: {},
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /[^@]+@[^@]+.[a-zA-Z]{2,6}/.test(v) || "E-mail must be valid",
      ],
      password: "",
      passwordRules: [
        (v) => !!v || "Password is required",
        /* (v) =>
          /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{7,15}$/.test(
            v
          ) ||
          "Password must have Numberic, Lowercase, Uppercase, special charactor ( !@#$%^&* ) and must between 6-12 charactors ",*/
      ],
    };
  },
  created() {
    //this.$vuetify.theme.dark = false;
  },
  mounted() {
    //
    //
    //axios.defaults.headers.common["Authorization"] = "Basic VHlyaW9uOndpbmU=";
  },
  methods: {
    login() {
      //
      const accessToken = generateJwtToken(process.env.VUE_APP_ACCESS_TOKEN_SECRET, {
        email: this.email,
        //password: this.password,
      });
      //const accessToken = "";
      this.postLogin(accessToken);
    },
    async postLogin(token) {
      //console.log("postLogin")
      //const url = process.env.VUE_APP_LOYALTY_API_URI;

      try {
        const payloadBody = {
          email: this.email,
          passwd: this.password,
          "token": token,
        };
        //console.log(payloadBody);
        await axios
          .post(
            this.api_uri + "/v1/customers/signin",
            payloadBody, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
              },
              //auth: { username: "Tyrion", password: "wine" },
            }
          )
          .then((response) => {
            //this.editedItem = response.data;
            console.log("response");
            console.log(response.data);
            let user = response.data.data;
            console.log(user);
            let userType = "CUSTOMER";
            if (response.data.code !== 0) {
              this.responseStatus = {
                status: "Error",
                code: 403,
                color: "red",
                type: "error",
                text: response.data.message,
                alertStatus: true,
              };
            } else {
              let custId = {};
              if (user.custId !== undefined) {
                custId = {
                  _id: user.custId._id,
                  apiKey: user.custId.apiKey,
                  package: user.custId.package,
                };
                //userType = "Shop";
                userType = user.userType;
              } else {
                custId = {
                  _id: user._id,
                  apiKey: user.apiKey,
                  package: user.package,
                };
              }
              //console.log("set storage");
              //sessionStorage.setItem("user",generateJwtToken(response.data.data));
              //console.log(response.data);
              if (user.lineliff_id === undefined) {
                user.lineliff_id = user.custId.lineliff_id;
                user.domain = user.custId.domain;
              }
              sessionStorage.setItem("profile", JSON.stringify(user));
              sessionStorage.setItem("user", user._id);
              sessionStorage.setItem("custId", custId._id);
              sessionStorage.setItem("token", response.data.token);
              sessionStorage.setItem("apiKey", custId.apiKey);
              sessionStorage.setItem("package", JSON.stringify(custId.package));
              sessionStorage.setItem("email", user.email);
              sessionStorage.setItem("userType", userType);
              this.$cookies.set("isAuth", true);
              this.$cookies.set("token", response.data.token);
              this.$cookies.set("userType", userType);

              //console.log(this.$store)
              //this.$router.push("/admin/dashboard?custId=" + user._id);
              window.location.href = "/admin/dashboard";
              //console.log(sessionStorage.getItem("user"));
            }
          });
      } catch (err) {
        console.log("err");
        console.log(err);
        this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        };
      }
    },
    reset() {
      //
    },
    handleAlert() {
      //console.log("alert");
      this.responseStatus = {};
    },
  },
};
</script>
<style scoped>
.body {
  width: 100%;
  height: 100%;
  background-color: ##f6f6f6;

  position: absolute;
  top: 0;
  bottom: 0;
}
.auth {
  margin-top: 25%;
  padding: 4px;
  background-color: ##ffffff;
}
.v-card .v-label.theme--light,
.v-card__title {
  color: white;
}
form {
  padding: 20px;
}

.head-title {
  background-color: #d6d6d6;
  color: #000;
  font-weight: 2em;
}

/deep/ .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {
  display: flex;
  flex: 1 1 auto;
  position: relative;
  background: white;
}
</style>
